function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1129",
  "data-name": "Group 1129",
  transform: "translate(-902 -342)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-list",
  "data-name": "Icon feather-list",
  transform: "translate(902.5 338)",
  opacity: 0.13
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_157",
  "data-name": "Path 157",
  d: "M12,9H69.486",
  transform: "translate(14.61)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_158",
  "data-name": "Path 158",
  d: "M12,18H69.486",
  transform: "translate(14.61 17.532)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_159",
  "data-name": "Path 159",
  d: "M12,27H69.486",
  transform: "translate(14.61 35.064)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_160",
  "data-name": "Path 160",
  d: "M4.5,9h0",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_161",
  "data-name": "Path 161",
  d: "M4.5,18h0",
  transform: "translate(0 17.532)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_162",
  "data-name": "Path 162",
  d: "M4.5,27h0",
  transform: "translate(0 35.064)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1128",
  "data-name": "Group 1128"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_34",
  "data-name": "Ellipse 34",
  cx: 24.5,
  cy: 24.5,
  r: 24.5,
  transform: "translate(965 365)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Icon_material-star",
  "data-name": "Icon material-star",
  d: "M20.919,30.362l11.074,6.684-2.939-12.6,9.784-8.476L25.954,14.88,20.919,3,15.884,14.88,3,15.973l9.784,8.476-2.939,12.6Z",
  transform: "translate(969 369)",
  opacity: 0.13
})));

function SvgNoRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 72,
    viewBox: "0 0 112 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRating);
export default __webpack_public_path__ + "static/media/noRating.48e1cf0a56fbe1c99a740e001b7e382a.svg";
export { ForwardRef as ReactComponent };